class ColourVariants extends HTMLElement {
  constructor() {
    super();
    this.variants = this.querySelectorAll(".js-variant-colour");
    this.quickAddModal = this.closest('quick-add-modal');
    this.isQuickAdd = this.quickAddModal ? true : false;
    this.parent = this.closest(".product__info-container");
    this.variants.forEach((el) => {
      el.addEventListener("click", () => {
        const url = el.getAttribute("data-product");
        if (url != window.location.pathname) {
          el.classList.add("loading");
          this.changeProduct(url, el);
        }
      });
    });
  }

  async changeProduct(url, el) {
    try {
      const checkedRadioBeforeUpdate = this.parent.querySelector("input[type='radio']:checked");

      // Determine which product details section to fetch based on what's currently displayed
      let productDetailsSectionId = 'product-details'; 
      
      if (document.querySelector('.product-details-accordion-wrapper')) {
        const currentAccordionSection = document.querySelector('.product-details-accordion-wrapper');
        if (currentAccordionSection && currentAccordionSection.closest('section')) {
          productDetailsSectionId = currentAccordionSection.closest('section').id.replace('section-', '');
        }
      }

      // Dynamically detect the recommendations section id 
      const recSectionElement = document.querySelector('.ua_product_recommendations') ? document.querySelector('.ua_product_recommendations').closest('section') : null;
      const recSectionId = recSectionElement ? recSectionElement.id.replace('shopify-section-', '') : null;

      const [productDetailsResponse, mainProductResponse, recommendationsResponse] = await Promise.all([
        fetch(`${url}?section_id=${productDetailsSectionId}`),
        fetch(`${url}?section_id=main-product`),
        recSectionId ? fetch(`${url}?section_id=${recSectionId}`) : Promise.resolve(undefined)
      ]);

      const [productDetailsText, mainProductText, recommendationsText] = await Promise.all([
        productDetailsResponse.text(),
        mainProductResponse.text(),
        recommendationsResponse && recommendationsResponse.status === 200 ? recommendationsResponse.text() : Promise.resolve("")
      ]);

      const productDetailsHtml = new DOMParser().parseFromString(productDetailsText, "text/html");
      const mainProductHtml = new DOMParser().parseFromString(mainProductText, "text/html");
      const recommendationsHtml = recommendationsText ? new DOMParser().parseFromString(recommendationsText, "text/html") : null;

      if (!this.isQuickAdd) {
        const newUrl = new URL(window.location);
        newUrl.pathname = url;

        window.history.replaceState(
          {},
          "",
          `${newUrl.pathname}${newUrl.search}`
        );
      }

      const variantRadios = this.parent.querySelector("variant-radios");
      if (variantRadios) {
        variantRadios.setAttribute("data-url", url);
      }

      // Quick Add Modal
      if (this.isQuickAdd) {
        const quickAddSource = mainProductHtml.querySelector(".quick-add-top");
        const quickAddDestination = this.quickAddModal.querySelector(".quick-add-top");
        if (quickAddSource && quickAddDestination)
          quickAddDestination.innerHTML = quickAddSource.innerHTML;
      }

      if (!this.isQuickAdd) {
        //media
        const mediaSource = mainProductHtml.querySelector(".product__media-wrapper");
        const mediaDestination = document.querySelector(
          ".product__media-wrapper"
        );
        if (mediaSource && mediaDestination)
          mediaDestination.innerHTML = mediaSource.innerHTML;

        //breadcrumb
        const breadcrumbSource = mainProductHtml.querySelector(".breadcrumbs");
        const breadcrumbDestination = document.querySelector(".breadcrumbs");
        if (breadcrumbSource && breadcrumbDestination)
          breadcrumbDestination.innerHTML = breadcrumbSource.innerHTML;

         // Stock Badge
        const badgeSource = mainProductHtml.querySelector('.product__badge');
        const badgeDestination = this.parent.querySelector('.product__badge');

        if (badgeSource && badgeDestination) {
          badgeDestination.outerHTML = badgeSource.outerHTML;
        } else if (!badgeSource && badgeDestination) {
          badgeDestination.remove();
        } else if (badgeSource && !badgeDestination) {
          const badgePlaceholder = this.parent.querySelector('.stockbadge_placeholder');
            if (badgePlaceholder) {
              badgePlaceholder.innerHTML = badgeSource.outerHTML;
            }
        }
        
        // scrolling promo
        this.updateScrollingPromo(mainProductHtml);

        //complete the set
        const additionsSource = mainProductHtml.querySelector(".js-product-additions");
        const additionsDestination = document.querySelector(
          ".js-product-additions"
        );
        if (additionsSource && additionsDestination)
          additionsDestination.innerHTML = additionsSource.innerHTML;

        //product top
        const productTopSource = mainProductHtml.querySelector(".product__top");
        const productTopDestination = document.querySelector(".product__top");
        if (productTopSource && productTopDestination) {
          const tempDiv = document.createElement('div');
          tempDiv.innerHTML = productTopSource.innerHTML;
          const promoInSource = tempDiv.querySelector('.scrolling-promo');
          if (promoInSource) {
            promoInSource.remove();
          }
          productTopDestination.innerHTML = tempDiv.innerHTML;
        }
      }

      //product lower
      const productLowerSource = mainProductHtml.querySelector(".product__lower");
      const productLowerDestination =
        this.parent.querySelector(".product__lower");
      if (productLowerSource && productLowerDestination) {
        productLowerDestination.innerHTML = productLowerSource.innerHTML;
        document.dispatchEvent(
          new CustomEvent('productLowerUpdated', {
            detail: { url }
          })
        );
      }

      const variantsSource = mainProductHtml.querySelector(".product__options-picker");
      const variantsDestination = this.parent.querySelector(".product__options-picker");
      if (variantsSource && variantsDestination) {
        variantsDestination.innerHTML = variantsSource.innerHTML;
        
        if (checkedRadioBeforeUpdate) {
          const radiosAfterUpdate = variantsDestination.querySelectorAll("input[type='radio']");
          radiosAfterUpdate.forEach(radio => {
            radio.checked = false;
            radio.removeAttribute('checked');

            if (radio.value === checkedRadioBeforeUpdate.value) {
              radio.checked = true;
              radio.setAttribute('checked', 'checked');
              radio.dispatchEvent(new Event('change', { bubbles: true }));
            }
          });
        }
      }

      // Update delivery date inputs
      this.updateDeliveryDateInputs(mainProductHtml);

      //colour value
      const colourSource = mainProductHtml.querySelector(
        "product-colour-variants .js-option-value"
      );
      const colourDestination = this.parent.querySelector(
        "product-colour-variants .js-option-value"
      );
      if (colourSource && colourDestination)
        colourDestination.innerHTML = colourSource.innerHTML;

      this.updateProductDetailsAccordion(productDetailsHtml);

      // recommendations update 
      if (recommendationsHtml) {
        this.updateRecommendations(recommendationsHtml);
      }

      // KiwiSizing functionality
      await this.updateKiwiSizingData(url);

      this.updateVariantStockData(mainProductHtml);
      document.dispatchEvent(
        new CustomEvent('colorVariantChanged', {
          detail: { url }
        })
      );

      // Re-apply wishlist visibility logic
      window.WishlistAB?.refresh();

      el.classList.remove("loading");
      this.removeActiveClasses();
      el.classList.add("active");
    } catch (error) {
      console.error('Error in changeProduct:', error);
      console.error('URL that failed:', url);
      el.classList.remove("loading");
    }
  }

  //KiwiSizing functionality
  async updateKiwiSizingData(url) {
    try {
      // Always remove existing chart first to ensure clean state
      const existingChart = document.querySelector('.ks-chart-container.sizing-chart-container.ks-container-with-modal');
      if (existingChart) {
        existingChart.remove();
      }

      const apiRes = await fetch(`${url}?view=metafield`);
      if (apiRes.ok) {
        const text = await apiRes.text();
        let apiData;
        try {
          apiData = JSON.parse(text);
        } catch (parseError) {
          console.error("JSON parse error!", parseError, text);
          return;
        }
        
        if (window.KiwiSizing && typeof window.KiwiSizing.data === 'object' && apiData) {
          const fieldsToUpdate = [
            'collections',
            'tags',
            'product',
            'vendor',
            'type',
            'title',
            'images',
            'options',
            'variants'
          ];
          
          // Update KiwiSizing data with new product data
          fieldsToUpdate.forEach((field) => {
            if (apiData.hasOwnProperty(field)) {
              window.KiwiSizing.data[field] = apiData[field];
            }
          });
          
          // Force reinitialize the sizing chart
          if (window.loadKiwiSizingChart) {
            setTimeout(() => {
              try {
                window.loadKiwiSizingChart();
              } catch (chartError) {
                console.error("Error loading KiwiSizing chart:", chartError);
              }
            }, 100);
          }
        }
      } else {
        // If no metafield data, ensure KiwiSizing data is cleared
        if (window.KiwiSizing && window.KiwiSizing.data) {
          // Clear or reset KiwiSizing data for variants without sizing
          const fieldsToReset = [
            'collections',
            'tags', 
            'product',
            'vendor',
            'type',
            'title',
            'images',
            'options',
            'variants'
          ];
          fieldsToReset.forEach(field => {
            if (window.KiwiSizing.data.hasOwnProperty(field)) {
              window.KiwiSizing.data[field] = null;
            }
          });
        }
      }
    } catch (e) {
      console.error("Failed to update KiwiSizing data:", e);
      const existingChart = document.querySelector('.ks-chart-container.sizing-chart-container.ks-container-with-modal');
      if (existingChart) {
        existingChart.remove();
      }
    }
  }

  updateProductDetailsAccordion(productDetailsHtml) {
    try {
      const newDetailsSection = productDetailsHtml.querySelector('.product-details');
      const wrapper = document.querySelector('.product-details-accordion-wrapper');
      if (!wrapper) return;
      const currentDetailsSection = wrapper.closest('section');

      if (newDetailsSection && currentDetailsSection) {
        currentDetailsSection.outerHTML = newDetailsSection.outerHTML;
      }
    } catch (error) {
      console.error('Error updating product details accordion:', error);
    }
  }

  updateRecommendations(recommendationsHtml) {
    try {
      const newRecs = recommendationsHtml.querySelector('.ua_product_recommendations');
      const currentRecs = document.querySelector('.ua_product_recommendations');

      if (newRecs && currentRecs) {
        currentRecs.outerHTML = newRecs.outerHTML;

        const sectionId = newRecs.closest('section') ? newRecs.closest('section').id.replace('shopify-section-', '') : null;
        if (sectionId && typeof hide_based_on_recently_viewed === 'function') {
          try {
            hide_based_on_recently_viewed(sectionId);
          } catch (e) {
            console.error('Error in hide_based_on_recently_viewed:', e);
          }
        }

        document.dispatchEvent(new CustomEvent('recommendationsUpdated', {
          detail: { sectionId: sectionId, element: newRecs }
        }));
      }
    } catch (error) {
      console.error('Error updating recommendations:', error);
    }
  }

  updateScrollingPromo(mainProductHtml) {
    try {
      const promoSource = mainProductHtml.querySelector('.promo-placeholder');
      const promoPlaceholder = document.querySelector('.promo-placeholder');

      if (promoPlaceholder) {
        const existingPromo = promoPlaceholder.querySelector('.scrolling-promo');
        if (existingPromo) {
          const animatedElements = existingPromo.querySelectorAll('.scrolling-promo__content');
          animatedElements.forEach(el => {
            el.style.animation = 'none';
          });
          
          if (existingPromo.dataset.promoId && window.promoIntervals) {
            try {
              clearInterval(window.promoIntervals[existingPromo.dataset.promoId]);
              delete window.promoIntervals[existingPromo.dataset.promoId];
            } catch (e) {
              console.error('Error clearing promo interval:', e);
            }
          }
        }
        
        if (promoSource) {
          promoPlaceholder.innerHTML = promoSource.innerHTML;
          this.initializePromoAfterUpdate();
        } else {
          promoPlaceholder.innerHTML = '';
        }
      }
    } catch (error) {
      console.error('Error updating scrolling promo:', error);
    }
  }

  initializePromoAfterUpdate() {
    setTimeout(() => {
      const newPromo = document.querySelector('.promo-placeholder .scrolling-promo');
      if (newPromo) {
        // Force CSS reflow to ensure styles are applied
        newPromo.offsetHeight;
        const promoId = newPromo.dataset.promoId;
        const scrollingContent = newPromo.querySelectorAll('.scrolling-promo__content');
        scrollingContent.forEach(content => {
          if (!newPromo.classList.contains('scrolling-promo--static')) {
            const scrollSpeed = content.dataset.scrollSpeed || '20';
            content.style.animation = `scroll-${promoId} ${scrollSpeed}s linear infinite`;
          }
        });
        
        if (window.initializeScrollingPromo) {
          try {
            window.initializeScrollingPromo(promoId);
          } catch (e) {
            console.error('Error in initializeScrollingPromo:', e);
          }
        }
        
        document.dispatchEvent(new CustomEvent('promoUpdated', {
          detail: { promoId: promoId, element: newPromo }
        }));
      }
    }, 50);
  }

  removeActiveClasses() {
    this.variants.forEach((el) => {
      el.classList.remove("active");
    });
  }

  updateVariantStockData(mainProductHtml) {
    if (!mainProductHtml) return;
    const stockScript = mainProductHtml.querySelector('[data-variant-stock]');
    if (!stockScript) return;
    const scriptContent = stockScript.textContent;
    if (!scriptContent || !scriptContent.trim()) return;

    window.variantStockData = {};
    const execScript = document.createElement('script');
    execScript.textContent = scriptContent;
    document.head.appendChild(execScript);
    execScript.parentNode?.removeChild(execScript);
  }

  updateDeliveryDateInputs(mainProductHtml) {
    if (!mainProductHtml) return;
    
    const sourceDeliveryInput = mainProductHtml.querySelector('.delivery-date-input');
    const deliveryInputs = document.querySelectorAll('.delivery-date-input');
    
    deliveryInputs.forEach(input => {
      if (sourceDeliveryInput) {
        input.value = sourceDeliveryInput.value;
      } else {
        input.value = '';
      }
    });
  }
}

customElements.define("product-colour-variants", ColourVariants);
